import { Button } from "@/components";
import styles from "@/styles/containers/configure.module.scss";
import classNames from "classnames/bind";
const css = classNames.bind(styles);

export function ConfigurationFieldLabel({ label, value, onClick }) {
  return (
    <div className={styles.field}>
      <div className="d-flex flex-col">
        <p className={styles.label}>{label}</p>
        <p
          className={css({
            value: true,
            filled: !!value,
          })}
        >
          {value || "---"}
        </p>
      </div>
      <Button onClick={onClick} design="default-mini">
        Editar
      </Button>
    </div>
  );
}
